import {
  FacebookShareButton,
  PinterestShareButton,
  TwitterShareButton,
} from "react-share";

function DesktopShare(props) {

  const instagramPage = () => {
    window.open("https://www.instagram.com/darveys/");
  }

  return (
    <div className="share mt-30">
      <ul>
        <li>
          <p className="text-black">Share:</p>
        </li>
        <li>
          <FacebookShareButton
            url={props.url || ""}
            quote={props.title + " " + props.description || ""}
            hashtag={""}
            description={props.title + " " + props.description || ""}
          >
            <img
              src={process.env.PUBLIC_URL + "/assets/images/icons/Facebook.svg"}
              className="img-fluid mx-auto d-block"
              alt=""
            />
          </FacebookShareButton>
        </li>
        <li>
          <button
            onClick={instagramPage}            
            target="_blank"
            rel="noopener noreferrer"
            className="react-share__ShareButton"
            style={{
              backgroundColor: "transparent",
              border: "none",
              padding: "0px",
              font: "inherit",
              color: "inherit",
              cursor: "pointer",
            }}
          >
            <img
              src="../assets/images/icons/Instagram.svg"
              className="img-fluid mx-auto d-block"
              alt=""
            />
          </button>
        </li>
        <li>
          <PinterestShareButton
            url={props.url || ""}
            description={props.title + " " + props.description || ""}
            media={props.imageUrl || ""}
          >
            <img
              src={
                process.env.PUBLIC_URL + "/assets/images/icons/Pinstrest.svg"
              }
              className="img-fluid mx-auto d-block"
              alt=""
            />
          </PinterestShareButton>
        </li>
        <li>
          <TwitterShareButton
            url={props.url || ""}
            title={props.title + " " + props.description || ""}
            hashtags={[]}
          >
            <img
              src={process.env.PUBLIC_URL + "/assets/images/icons/Twitter.svg"}
              className="img-fluid mx-auto d-block"
              alt=""
            />{" "}
          </TwitterShareButton>
        </li>
      </ul>
    </div>
  );
}

export default DesktopShare;
